import { createSlice } from '@reduxjs/toolkit';

const commonSlice = createSlice({
  name: 'commonSlice',
  initialState: {
    navBarToggle: false,
    viewsData: {},
    wizardCurrentView: {
      step: 0,
    },
    candidateSearchFilters: '',
    candidatesFiltersUrl: '',
    jobData: { state: null, job: null, formValues: null },
  },
  reducers: {
    handleNavToggle: (state, action) => {
      action.payload === undefined
        ? (state.navBarToggle = !state.navBarToggle)
        : (state.navBarToggle = action.payload);
    },
    handleViewsData: (state, action) => {
      state.viewsData = action?.payload;
    },
    handleCurrentView: (state, action) => {
      state.viewsData.currentView = action?.payload;
    },
    updateWizardStep: (state, action) => {
      state.wizardCurrentView = action?.payload;
    },
    handleCandidateSearchFilters: (state, action) => {
      state.candidateSearchFilters = action?.payload;
    },
    handleCandidateFiltersUrls: (state, action) => {
      state.candidatesFiltersUrl = action?.payload;
    },
    handleJobData: (state, action) => {
      if (action?.payload?.state !== undefined) {
        state.jobData.state = action.payload.state;
      }
      if (action?.payload?.job !== undefined) {
        state.jobData.job = action.payload.job;
      }
      if (action?.payload?.formValues !== undefined) {
        state.jobData.formValues = action.payload.formValues;
      }
    },
  },
});

export const {
  handleNavToggle,
  handleViewsData,
  handleCurrentView,
  updateWizardStep,
  handleCandidateSearchFilters,
  handleCandidateFiltersUrls,
  handleJobData,
} = commonSlice.actions;
export default commonSlice.reducer;
